// File: src/components/MissingOrders.js

import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button } from "react-bootstrap";
import ApiManager from "../utils/ApiManager";
import RowCountLabel from "./RowCountLabel";
import RefreshIcon from "@mui/icons-material/Refresh";

import "./Movements.css"; // Riutilizza lo stesso stile per coerenza
import "./MissingOrders.css"; // <-- aggiungiamo un CSS dedicato

const MissingOrders = () => {
  const [missingOrders, setMissingOrders] = useState([]);

  const fetchData = () => {
    ApiManager.Top.missingOrders(
      (data) => {
        setMissingOrders(data.missingOrders || []);
      },
      (error) => {
        console.error("Error fetching missing orders:", error);
      },
      () => {}
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="movements">
      <Row className="mb-3">
        <Col></Col>
        <Col className="text-end">
          <Button variant="secondary" onClick={fetchData} title="Aggiorna dati">
            <RefreshIcon />
          </Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <RowCountLabel
            count={missingOrders?.length}
            label="Ordini Mancanti trovati"
          />

          {/* Contenitore scrollabile */}
          <div className="table-container">
            <Table striped bordered hover size="sm">
              <thead className="sticky-header">
                <tr>
                  <th>Data</th>
                  <th>Num</th>
                  <th>Serie</th>
                  <th>Sito</th>
                  <th>Rif Ordine</th>
                  <th>Cod Cli</th>
                  <th>Fatturazione</th>
                  <th>Destinazione</th>
                  <th>Agente</th>
                  <th>Trasporto</th>
                  <th>Pagamento</th>
                  <th>Note Interne</th>
                  <th>Note Cliente</th>
                </tr>
              </thead>
              <tbody>
                {missingOrders?.map((row, index) => (
                  <tr key={`missingOrder-${row.Id}-${index}`}>
                    <td>{row.Date}</td>
                    <td>{row.Num}</td>
                    <td>{row.Series}</td>
                    <td>{row.Domain}</td>
                    <td>{row.OrderRef}</td>
                    <td>{row.ContactId}</td>
                    <td>{row.Billing}</td>
                    <td>{row.Dest}</td>
                    <td>{row.AgentDescr}</td>
                    <td>{row.ShippingTypeDescr}</td>
                    <td>{row.PaymentDescr}</td>
                    <td>{row.InternalNotes}</td>
                    <td>{row.CustomerNotes}</td>
                  </tr>
                ))}
                {missingOrders?.length === 0 && (
                  <tr>
                    <td colSpan="13" className="text-center text-muted">
                      Nessun dato disponibile
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MissingOrders;
